import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import Chatbox from './Chatbox';

export default function ChatWidget({ subjectId }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isOpen ? (
        <div className="relative w-[22rem] sm:w-[24rem] max-w-full max-h-[calc(100vh-6rem)] overflow-hidden">
          <div className="bg-white border shadow-lg rounded-lg overflow-hidden">
            <div className="flex justify-between items-center px-3 py-2 border-b bg-blue-600 text-white">
              <span className="font-semibold">Sva Learn Chatbot</span>
              <button onClick={() => setIsOpen(false)} className="hover:text-gray-300">
                <X size={20} />
              </button>
            </div>
              <Chatbox subjectId={subjectId} />
          </div>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-blue-600 text-white rounded-full p-3 shadow-lg hover:bg-blue-700 transition"
        >
          <div className="relative">
            <MessageCircle size={28} className="animate-pulse text-blue-500" />
            <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs px-1.5 py-0.5 rounded-full animate-bounce">
              SvaLearn
            </span>
          </div>
        </button>
      )}
    </div>
  );
}
